export default __webpack_public_path__ + "static/media/glenfernmultistoreytop1.c4e7ca4e.png";